module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-success"
  }, [_c('Icon'), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Your password has been reset")]), _vm._v(" "), _c('Iconsuccess', {
    staticStyle: {
      "margin-top": "65px"
    }
  }), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-top": "55px"
    },
    attrs: {
      "type": 'Going back to sign in page'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6bb202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Resetsuccess.vue
// module id = 776
// module chunks = 1